import $ from 'jquery';
import './campaign/Tracking.mjs';
import 'jquery-colorbox';

export default class Campaign {
  constructor() {
    var $blockWinner = $('#block-winner');

    //shuffle
    $.each($blockWinner.find('div.row'), function(index, el) {
      var $el = $(el);
      var $find = $el.children();

      $find.sort(function() {
        return 0.5 - Math.random();
      });

      $el.empty();
      $find.appendTo($el).css('visibility', 'visible');
    });

    if ($blockWinner.length) {
      var $galleryItems = $blockWinner.find( ".block-gallery__item" );
      $galleryItems.colorbox( {
        rel: "contest-gallery",
        opacity: 0.6,
        loop: false,
        maxWidth: "99%",
        maxHeight: "99%",
        current: "",
        previous: "<span class='sr-only'>vorheriges Bild</span>",
        next: "<span class='sr-only'>nächstes Bild</span>",
        close: "<span class='sr-only'>schließen</span>"
      });
    }
  }
}
